/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
@file:OptIn(ExperimentalTime::class)

package com.macrofocus.high_d.axis

import com.macrofocus.common.crossplatform.CPHelper
import com.macrofocus.common.filter.MutableFilter
import com.macrofocus.common.selection.Selection
import com.macrofocus.common.selection.SingleSelection
import org.mkui.component.CPFactory
import org.molap.dataframe.DataFrame
import org.molap.subset.SubsetDataFrame
import kotlin.reflect.KClass
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

/**
 * Created by luc on 25/07/16.
 */
class AxisFactory<R, C>(
    dataFrame: DataFrame<R, C, *>,
    subsetDataFrame: SubsetDataFrame<R, C, *>?,
    annotationDataFrame: DataFrame<*, C, *>?,
    probing: SingleSelection<R>,
    selection: Selection<R>,
    filter: MutableFilter<R>
) {
    private val axisModels: MutableMap<C, AxisModel<R, C>>
    private val dataFrame: DataFrame<R, C, *>
    private val subsetDataFrame: SubsetDataFrame<R, C, *>?
    private val annotationDataFrame: DataFrame<*, C, *>?
    private val probing: SingleSelection<R>
    private val selection: Selection<R>
    private val filter: MutableFilter<R>
    fun getAxisModel(c: C): AxisModel<R, C>? {
        return if (!axisModels.containsKey(c)) {
            val axisModel: AxisModel<R, C>? = createAxisModel(c)
            if (axisModel != null) {
                axisModels[c] = axisModel
                axisModel
            } else {
                null
            }
        } else {
            axisModels[c]
        }
    }

    private fun createAxisModel(c: C): AxisModel<R, C>? {
        val axisModel: AxisModel<R, C>?
        if (dataFrame.columnIndex.contains(c)) {
            val columnClass: KClass<out Any> = dataFrame.getColumnClass(c)
            if (CPHelper.instance.isNumericType(columnClass)) {
                axisModel = DefaultAxisModel<R, C>(dataFrame, annotationDataFrame, subsetDataFrame, c, probing, selection, filter)
            } else if (CPHelper.instance.isAssignableFrom(Instant::class, columnClass)) {
                axisModel = DateAxisModel<R, C>(CPFactory.instance, dataFrame, annotationDataFrame, subsetDataFrame, c, probing, selection, filter)
            } else if (CPHelper.instance.isAssignableFrom(Comparable::class, columnClass)) {
                axisModel = CategoricalAxisModel<R, C>(dataFrame, annotationDataFrame, subsetDataFrame, c, probing, selection, filter)
            } else {
//                System.err.println("Cannot create axis model for " + c + " (" + c.getClass() + ")");
//                axisModel = null;
                axisModel = GenericAxisModel<R, C>(dataFrame, annotationDataFrame, subsetDataFrame, c, probing, selection, filter)
            }
        } else {
            println("Cannot find column name $c")
            axisModel = null
        }
        return axisModel
    }

    init {
        this.dataFrame = dataFrame
        this.subsetDataFrame = subsetDataFrame
        this.annotationDataFrame = annotationDataFrame
        this.probing = probing
        this.selection = selection
        this.filter = filter
        axisModels = HashMap<C, AxisModel<R, C>>()
    }
}